// How a project's components were found, in words. The scope sync stores codes in each row's
// `componentSource` (predict_scope/from_sbom.py: installed, vendor-sbom, none) and the watch list sends
// `vendor-product` for a vendor's own product; this is the one place they become words. A vendor's SBOM
// reads as the vendor's own name, "F5 SBOM", so no vendor needs words of its own anywhere.

const WORDS = {
  installed: () => 'installed packages',
  'vendor-sbom': vendorName => `${vendorName || 'Vendor'} SBOM`,
  none: () => 'no SBOM',
  'vendor-product': () => 'vendor product'
};

/** One code in words, for the vendor named `vendorName`. A value that isn't a code shows as it is. */
export const sourceWords = (code, vendorName) => (WORDS[code] ? WORDS[code](vendorName) : code);

/** A row's `componentSource` ("installed, vendor-sbom") as its codes. */
export const sourceCodes = componentSource =>
  typeof componentSource === 'string' ? componentSource.split(', ').filter(Boolean) : [];

// The codes a page treats specially: a host's own packages (shown as the best source) and a
// release with no SBOM (shown neutral).
export const INSTALLED = 'installed';
export const NO_SBOM = 'none';
